import { useMutation } from '@tanstack/react-query';

import type { DeleteStaffAccessPassResponse } from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useDeleteStaffAccessPassMutation = () =>
  useMutation({
    mutationFn: (params: { url: string; id: number }) =>
      HttpClient.request<DeleteStaffAccessPassResponse>({
        method: 'DELETE',
        url: `${params.url}/${params.id}`,
      }),
  });
